/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  today: 'à²à²à²¦à³',
  now: 'à²à²',
  backToToday: 'à²à²à²¦à³ à²¹à²¿à²à²¦à²¿à²°à³à²à²¿',
  ok: 'à²¸à²°à²¿',
  clear: 'à²¸à³à²ªà²·à³à²',
  month: 'à²¤à²¿à²à²à²³à³',
  year: 'à²µà²°à³à²·',
  timeSelect: 'à²¸à²®à²¯ à²à²¯à³à²à³à²®à²¾à²¡à²¿',
  dateSelect: 'à²¦à²¿à²¨à²¾à²à²à²µà²¨à³à²¨à³ à²à²¯à³à²à³ à²®à²¾à²¡à²¿',
  weekSelect: 'à²à²à²¦à³ à²µà²¾à²°à²¦ à²à²°à²¿à²¸à²¿',
  monthSelect: 'à²à²à²¦à³ à²¤à²¿à²à²à²³à³ à²à²¯à³à²à³à²®à²¾à²¡à²¿',
  yearSelect: 'à²à²à²¦à³ à²µà²°à³à²· à²à²°à²¿à²¸à²¿',
  decadeSelect: 'à²à²à²¦à³ à²¦à²¶à²à²¦ à²à²¯à³à²à³à²®à²¾à²¡à²¿',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'à²¹à²¿à²à²¦à²¿à²¨ à²¤à²¿à²à²à²³à³ (à²ªà³à²à³à²à²ªà³)',
  nextMonth: 'à²®à³à²à²¦à²¿à²¨ à²¤à²¿à²à²à²³à³ (à²ªà³à²à³à²¡à³à²¨à³)',
  previousYear: 'à²à²³à³à²¦ à²µà²°à³à²· (Ctrl + à²à²¡)',
  nextYear: 'à²®à³à²à²¦à²¿à²¨ à²µà²°à³à²· (Ctrl + à²¬à²²)',
  previousDecade: 'à²à²³à³à²¦ à²¦à²¶à²',
  nextDecade: 'à²®à³à²à²¦à²¿à²¨ à²¦à²¶à²',
  previousCentury: 'à²à²³à³à²¦ à²¶à²¤à²®à²¾à²¨',
  nextCentury: 'à²®à³à²à²¦à²¿à²¨ à²¶à²¤à²®à²¾à²¨'
};
